import React from 'react';
import { useSelector } from 'react-redux';
import { CartEmpty } from '@yme/assets/icons';
import { Col, Container } from '@yme/atoms/grid';
import { InfoBlockEmptyResults } from '@yme/atoms/info-block-empty-results';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { IndentWrapper } from '@yme/components/Separator';
import { useWishlist } from '@yme/hooks/useWishlist';
import { AccessoriesCard } from '@yme/molecules/cards';
import { getRootLang, getRTL } from '@yme/selectors/common';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { HeadingLevel2 } from '@yme/tokens/typography';
import { itemToCard, replacePlaceholders } from './helpers';
import { CounterSectionStyled, HeaderRowStyled, HeaderStyled, ProductCardStyled, ProductCardWrapperStyled, } from './styled';
export function WishlistGrid(props) {
    const rootLanguage = useSelector(getRootLang);
    const isRightToLeft = useSelector(getRTL);
    const { items, removeFromWishlist } = useWishlist();
    const { isRemoveBottomIndent, title, labels } = props;
    const itemsCount = items.length;
    const onRemove = (sku) => {
        return async (e) => {
            e.preventDefault();
            await removeFromWishlist(sku);
        };
    };
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(Container, { pt: '96px' },
            (title || !!itemsCount) && (React.createElement(HeaderRowStyled, { justifyContent: title?.length ? 'space-between' : 'flex-end', alignItems: "center", rowGap: INDENT.xs },
                title && (React.createElement(Col, { lg: 6, md: 4, sm: 12 },
                    React.createElement(HeaderStyled, { isRightToLeft: isRightToLeft },
                        React.createElement(HeadingLevel2, null, title)))),
                !!itemsCount && (React.createElement(Col, { lg: 6, md: 4, sm: 12 },
                    React.createElement(CounterSectionStyled, { color: colorCoreBlack900Base }, replacePlaceholders(labels.wishlist_counter_label, String(itemsCount))))))),
            React.createElement(ProductCardWrapperStyled, { flexDirection: "row", flexWrap: "wrap", gap: INDENT.sm, mlDesktop: INDENT.xl, mrDesktop: INDENT.xl, mlTablet: INDENT.sm, mrTablet: INDENT.sm, mlMobile: INDENT.xs, mrMobile: INDENT.xs }, itemsCount ? (items.map((item) => {
                return (React.createElement(ProductCardStyled, { key: item.sku },
                    React.createElement(AccessoriesCard, { isRightToLeft: isRightToLeft, cardProps: itemToCard(item), language: rootLanguage, onRemove: onRemove(item.sku) })));
            })) : (React.createElement(FlexWrapper, { isFullWidth: true, alignItems: "center", justifyContent: "center" },
                React.createElement(InfoBlockEmptyResults, { customIcon: React.createElement(SVGIcon, { type: CartEmpty, size: ICON_SIZE.xxxxxl }), verticalIndentTablet: INDENT.xl, titleEmptyResults: labels.wishlist_noItems_label, descriptionEmptyResults: labels.wishlist_hintToAddItems_label, isFullWidth: true })))))));
}
